<template>
  <div class="container-fluid my-profile">
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>

    <div class="row clearfix row-deck">
      <!-- Account Holder Information -->
      <div class="col-lg-6 col-md-12 sol-sm-12">
        <account-holder-information></account-holder-information>
      </div>

      <!-- Basic Business Information -->
      <div class="col-lg-6 col-md-12 sol-sm-12">
        <basic-business-information
          @onBusinessTypeChange="businessTypeChange"
        ></basic-business-information>
      </div>

      <!-- Business Contact Details -->
      <div class="col-lg-6 col-md-12 sol-sm-12">
        <business-contact-detail
          :businessType="businessType"
        ></business-contact-detail>
      </div>

      <!-- Tell us about your needs -->
      <div class="col-lg-6 col-md-12 sol-sm-12">
        <tell-us-about-your-needs></tell-us-about-your-needs>
      </div>

      <!-- Controllers of your Business -->
      <!-- Directors -->
      <div
        class="col-lg-6 col-md-12 sol-sm-12"
        v-if="businessType == 'Business'"
      >
        <directors-component></directors-component>
      </div>
      <!-- Shareholders -->
      <div
        class="col-lg-6 col-md-12 sol-sm-12"
        v-if="businessType == 'Business'"
      >
        <shareholders-component></shareholders-component>
      </div>
      <!-- Ultimate Beneficial Owner (UBO) -->
      <div
        class="col-lg-6 col-md-12 sol-sm-12"
        v-if="businessType == 'Business'"
      >
        <ubo-component></ubo-component>
      </div>

      <!-- Business Structure, Condition and Size -->
      <div
        class="col-lg-6 col-md-12 sol-sm-12"
        v-if="businessType == 'Business'"
      >
        <business-structure-condition-size></business-structure-condition-size>
      </div>

      <!-- Your Business and Regulations -->
      <div
        class="col-lg-6 col-md-12 sol-sm-12"
        v-if="businessType == 'Business'"
      >
        <business-regulations-component></business-regulations-component>
      </div>

      <!-- Compliance Declarations -->
      <div class="col-lg-6 col-md-12 sol-sm-12">
        <compliance-declarations-component
          :businessType="businessType"
        ></compliance-declarations-component>
      </div>

      <!-- Supporting Documents -->
      <div class="col-lg-12 col-md-12 sol-sm-12">
        <supporting-documents-component
          :businessType.sync="businessType"
        ></supporting-documents-component>
      </div>

      <!-- Finally, in case we need to reach you who should we contact? -->
      <div class="col-lg-12 col-md-12 sol-sm-12">
        <contact-component></contact-component>
      </div>

      <!-- Business Logo -->
      <div class="col-lg-6 col-md-12 sol-sm-12">
        <business-logo-component></business-logo-component>
      </div>

      <!-- Logo Icon -->
      <div class="col-lg-6 col-md-12 sol-sm-12">
        <logo-icon-component></logo-icon-component>
      </div>

      <!-- Profile Photo -->
      <div class="col-lg-6 col-md-12 sol-sm-12">
        <profile-photo-component></profile-photo-component>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "MyProfileComponent",
  components: {
    BreadCrumb: () => import("@/components/BreadCrumb.vue"),
    "account-holder-information": () =>
      import("@/components/core/AccountHolderInfo-Profile.vue"),
    "basic-business-information": () =>
      import("@/components/core/BasicBusinessInfo-Profile.vue"),
    "business-contact-detail": () =>
      import("@/components/core/BusinessContactDetails-Profile.vue"),
    "tell-us-about-your-needs": () =>
      import("@/components/core/YourNeeds-Profile.vue"),
    "directors-component": () =>
      import("@/components/core/Director-Profile.vue"),
    "shareholders-component": () =>
      import("@/components/core/Shareholders-Profile.vue"),
    "ubo-component": () => import("@/components/core/UBO-Profile.vue"),
    "business-structure-condition-size": () =>
      import("@/components/core/BusinessStructure-Profile.vue"),
    "compliance-declarations-component": () =>
      import("@/components/core/ComplianceDeclarations-Profile.vue"),
    "business-logo-component": () =>
      import("@/components/core/BusinessLogo-Profile.vue"),
    "logo-icon-component": () =>
      import("@/components/core/LogoIcon-Profile.vue"),
    "profile-photo-component": () =>
      import("@/components/core/ProfilePhoto-Profile.vue"),
    "supporting-documents-component": () =>
      import("@/components/core/SupportingDocument-Profile.vue"),
    "contact-component": () => import("@/components/core/Contact-Profile.vue"),
    "business-regulations-component": () =>
      import("@/components/core/BusinessRegulations-Profile.vue"),
  },
  data() {
    return {
      businessType: "Business",
    };
  },
  methods: {
    businessTypeChange(value) {
      this.businessType = value;
    },
  },
};
</script>
